import React, { useState } from 'react';
import { __SiPayConfirmationModalProps, __SiPayConfirmationModalRef } from './confirmationModal.interface';
import { _SiPayModal as SiPayModal } from '../30payModal/30payModal.index';
import { Button } from '30pay/components';

export interface SiPayConfirmationModalRef extends __SiPayConfirmationModalRef {}
const _ConfirmationModal: React.ForwardRefRenderFunction<__SiPayConfirmationModalRef, __SiPayConfirmationModalProps> = (
    props: __SiPayConfirmationModalProps,
    ref,
) => {
    const [isLoading, setIsLoading] = useState(false);

    React.useImperativeHandle(ref, () => ({
        startLoading: () => setIsLoading(true),
        stopLoading: () => setIsLoading(false),
    }));

    return (
        <SiPayModal maxWidth={400} isOpen={props.isOpen} onClose={props.onClose} title={props.title}>
            <div className="w-full h-full flex flex-col items-center justify-center gap-6">
                <div className="flex flex-col items-center justify-center">
                    <p className="font-medium text-lg text-darkPurple-100 max-lg:text-base text-center">{props.message}</p>
                    <p className="font-medium text-lg text-darkPurple-100 max-lg:text-base text-center">آیا مطمئن هستید؟</p>
                </div>
                <div className="flex items-center gap-4 w-full">
                    <Button
                        loading={isLoading}
                        onClick={props.onConfirm}
                        type="primary"
                        className="bg-negative-default w-full hover:opacity-50 hover:!bg-negative-default"
                    >
                        {props.submitButtonText}
                    </Button>
                    <Button onClick={props.onClose} type="text" className="bg-background w-full">
                        انصراف
                    </Button>
                </div>
            </div>
        </SiPayModal>
    );
};

export default React.forwardRef(_ConfirmationModal);
